var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-container"},[_c('v-btn',_vm._g(_vm._b({staticClass:"text-capitalize",attrs:{"text":"","color":"addButtonText"}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',{staticClass:"mr-1",attrs:{"left":"","color":"success","size":_vm.iconSize}},[_vm._v(_vm._s(_vm.icon))]),_c('div',{class:{
        'small-font-size': _vm.smallFont,
        'add-button-text': !_vm.smallFont,
        'mobile-font-size': !_vm.smallFont && _vm.$vuetify.breakpoint.smAndDown,
        'desktop-font-size': !_vm.smallFont && _vm.$vuetify.breakpoint.mdAndUp
      }},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }